// Packages
import ListItem from 'modules/Users/components/ListItem';
import PropTypes from 'prop-types';

const UserList = ({ isLoading, items, onChange }) => {

	// Loading State
	if ( isLoading )
	{
		return (
			<div className='UserList'>
					<ListItem isLoading={true}/>
			</div>
		)
	}


	// Empty State
	if ( items.length === 0 )
	{
		return (
			<h3 className='opacity italic'>No users to show here</h3>
		)
	}


	// Data State
	return (
		<div className='UserList'>

			{items.map((item, index) => {

				return (
						<ListItem 
							{...item} 
							key={index}
							isLoading={false}
							onChange={() => {onChange()}}
						/>
				)
				
			})}
	
		</div>
	)
}

UserList.propTypes = {
	isLoading: PropTypes.bool,
	items: PropTypes.array,
	onChange: PropTypes.func,
}

UserList.defaultProps = {
	isLoading: false,
	items: [],
	onChange: () => {'onChange is not set!'},
}

export default UserList;